import { PlaceholderReplacements } from '@/Support/Common/Functions/PlaceholdersReplacer'
import { trans, transChoice } from 'laravel-vue-i18n'

export function t(words: string, parameters?: PlaceholderReplacements) {
  return trans(words, parameters)
}

export function tt(key: string | number, parameters?: PlaceholderReplacements) {
  return trans(key, parameters)
}

export function ttc(
  key: string | number,
  number: number,
  parameters?: PlaceholderReplacements,
) {
  return transChoice(key, number, parameters)
}
